var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"ok-variant":"danger","cancel-title":_vm.defaultCancelTitle,"ok-title":_vm.defaultOkTitle,"title":_vm.title},on:{"ok":function($event){_vm.confirm()}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb0d49be","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/CallbackModal.vue
// module id = iNqv
// module chunks = 70